import styled from 'styled-components';
import { EmptyState } from 'ui/emptyState';
import { DiscardedEmptyState } from 'ui/illustrations';
import { spacing, WebLink } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { Card } from './BillingPage.styled';
import { CardBody } from './PaymentsCard.styled';

const CardBodyWithPadding = styled(CardBody)`
  padding: ${spacing.x3} 0;
`;

const EmptyStateMaxWidth = styled(EmptyState)`
  max-width: ${pxToRem(700)};
  margin: 0 auto;
`;

export const PaymentsMigratedCard = () => (
  <Card>
    <CardBodyWithPadding>
      <EmptyStateMaxWidth
        Illustration={DiscardedEmptyState}
        title="Looking for your credit card information?"
        subtitle={
          <>
            Credit cards are no longer managed on this page, but don&apos;t worry, we&apos;re still
            here to help!
            <br />
            Please contact{' '}
            <WebLink href="mailto:billing@iterable.com">billing@iterable.com</WebLink> if you need
            any assistance.
          </>
        }
      />
    </CardBodyWithPadding>
  </Card>
);
